import apiBase from './base';

export const getAllTeams = () => apiBase.get('/clubs');

export const getParticipants = tournamentId =>
  apiBase.get(`/tournaments/${tournamentId}/participants`);

export const addParticipantToGroup = (tournamentId, groupId, club_id) =>
  apiBase.post(`/tournaments/${tournamentId}/groups/${groupId}/add_club`, {
    body: {
      data: { club: { club_id } },
    },
  });

export const removeParticipantFromGroup = (tournamentId, groupId, club_id) =>
  apiBase.post(`/tournaments/${tournamentId}/groups/${groupId}/remove_club`, {
    body: {
      data: { club: { club_id } },
    },
  });

export const getTeamMembers = (tournamentId, groupId) =>
  apiBase.get(`/tournaments/${tournamentId}/clubs/${groupId}/lineups`);

export const getLineupRequests = (tournamentId, groupId, page = 1) =>
  apiBase.get(
    `/tournaments/${tournamentId}/lineup_requests?q[club_member_club_id_eq]=${groupId}&state=pending&page=${page}&items=9`,
  );

export const changeLineupRequestStatus = (tournamentId, lineupRequestId, status) =>
  apiBase.patch(`/tournaments/${tournamentId}/lineup_requests/${lineupRequestId}/status`, {
    body: {
      data: { status },
    },
  });
